import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { DashboardResultType } from '@api/domain/types';
import { DASHBOARD_RESULT_TYPE_OPTIONS } from '@v2/pages/dashboard/common/constants/selections';
import { selectDashboardResultType, setDashboardResultType } from '@reducers/v2/dashboard/dashboard.slice';

export const useManageDashboardHeaderResultTypeChip = () => {
  const dispatch = useAppDispatch();
  const resultType = useSelector(selectDashboardResultType);

  const currentLabel = useMemo(
    () => DASHBOARD_RESULT_TYPE_OPTIONS.find((o) => o.value === resultType)?.label ?? '',
    [resultType]
  );

  const onChange = useCallback(
    (value: DashboardResultType) => dispatch(setDashboardResultType(value)),
    [dispatch]
  );

  return { resultType, currentLabel, onChange };
};
